import type { ProductType } from "@memorang/types";

export const resolveExamDefaultProductType = (
	studyPackCollectionId: number | undefined,
): ProductType => (studyPackCollectionId ? "STUDY_PACK" : "PRACTICE_TEST");
